import { render, staticRenderFns } from "./consentManagementWithProduct.vue?vue&type=template&id=9fc32624&"
import script from "./consentManagementWithProduct.vue?vue&type=script&lang=js&"
export * from "./consentManagementWithProduct.vue?vue&type=script&lang=js&"
import style0 from "./consentManagementWithProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/work/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fc32624')) {
      api.createRecord('9fc32624', component.options)
    } else {
      api.reload('9fc32624', component.options)
    }
    module.hot.accept("./consentManagementWithProduct.vue?vue&type=template&id=9fc32624&", function () {
      api.rerender('9fc32624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/consentManagement/consentManagementWithProduct.vue"
export default component.exports